<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="p-fluid">
  <app-header icon="fas fa-circle-dot" text="Punktgröße" />
  <div class="grid">
    <div class="col-4">
      <app-ngx-slider
        labelFloor="klein"
        labelCeil="groß"
        [options]="{ ceil: 4, floor: 0.5, step: 0.2 }"
        formControlName="dotSize"></app-ngx-slider>
    </div>
  </div>
  <p-divider />
  <app-header icon="fas fa-slash" text="Regressionsgerade"></app-header>
  <div class="grid">
    <app-form-field-wrapper
      [hideLabel]="true"
      [floatingLabel]="false"
      [name]="'displayRegression'"
      [colSize]="6">
      <p-checkbox
        [binary]="true"
        label="Regressionsgerade einblenden"
        name="displayRegression"
        formControlName="displayRegression"></p-checkbox>
    </app-form-field-wrapper>
  </div>
</form>
